export default "__VITE_ASSET__DLrv7d9G__"